import { css } from '@emotion/react';
import { ReactElement } from 'react';

import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';

type IconInterface = {
	className: string;
};

const styles = css`
	text-align: center;
`;

const Component = ({ className }: IconInterface): ReactElement => {
	const theme = useTheme();
	return (
		<div className={className}>
			<svg
				width={theme.allSettings.icons.phoneIcon.width}
				viewBox="0 0 41 41"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M.022 32.41c0-.202 0-.405.087-.609.203-.609 1.625-1.247 2.205-1.538 1.654-.928 3.337-1.828 4.962-2.785.755-.465 1.683-1.335 2.583-1.335 1.77 0 4.352 5.252 5.92 5.252.783 0 1.799-.725 2.495-1.132 5.281-2.93 8.938-6.587 11.868-11.868.407-.696 1.132-1.712 1.132-2.495 0-1.567-5.252-4.15-5.252-5.92 0-.9.87-1.828 1.335-2.583.957-1.625 1.857-3.308 2.785-4.962.29-.58.929-2.002 1.538-2.205.203-.087.407-.087.61-.087 1.044 0 3.075.464 4.033.9 1.422.609 2.35 2.234 3.076 3.54.929 1.712 1.48 3.453 1.48 5.397 0 2.699-1.103 5.136-2.002 7.603-.639 1.77-1.422 3.482-2.409 5.078-3.047 4.933-8.995 10.881-13.928 13.928-1.596.987-3.308 1.77-5.078 2.409-2.467.9-4.905 2.002-7.603 2.002-1.944 0-3.685-.551-5.398-1.48-1.305-.725-2.93-1.654-3.54-3.076-.435-.957-.9-2.989-.9-4.033z"
					fill={theme.allSettings.icons.phoneIcon.fill}
				/>
			</svg>
		</div>
	);
};

const PhoneIcon = styled(Component)(
	({
		theme: {
			allSettings: {
				icons: { phoneIcon },
			},
		},
	}: {
		theme: Theme;
	}) => phoneIcon,
	styles
);

export { PhoneIcon };
